import { NavLink as RouterNavLink, NavLinkProps } from "react-router-dom";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { usePrefetchRoute } from "@/hooks/use-prefetch-route";

interface NavLinkCompatProps extends Omit<NavLinkProps, "className"> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  ({ className, activeClassName, pendingClassName, to, ...props }, ref) => {
    const { prefetch, cancel } = usePrefetchRoute();
    const path = typeof to === 'string' ? to : to.pathname ?? '';

    return (
      <RouterNavLink
        ref={ref}
        to={to}
        onMouseEnter={() => prefetch(path)}
        onMouseLeave={cancel}
        className={({ isActive, isPending }) =>
          cn(className, isActive && activeClassName, isPending && pendingClassName)
        }
        {...props}
      />
    );
  },
);

NavLink.displayName = "NavLink";

export { NavLink };
